// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_AT_RULE_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js!../../../node_modules/@material/button/dist/mdc.button.min.css");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
exports.push([module.id, ".mdc-button {\n    --mdc-theme-primary: #1976d2;\n    --mdc-theme-secondary: #000000;\n    font-family: 'Nunito Sans', Sans-serif, sans-serif;\n}\n\n.mdc-button--outlined:not(:disabled) {\n    border-color: var(--mdc-theme-primary);\n}\n", ""]);
// Exports
module.exports = exports;
